import { HardwareOrderStatus } from "interfaces";

/**
 * Represents the selectable status options used to filter hardware orders.
 *
 * The statuses are grouped into two categories:
 * - Open Status: Orders that are currently being processed or are awaiting further actions.
 * - Complete Status: Orders that have reached a final state (fulfilled, cancelled, or rejected).
 *
 * @constant
 * @type {Array<{ label: string; options: Array<{ label: string; value: HardwareOrderStatus }> }>}
 */
export const STATUS_OPTIONS = [
  {
    label: "Open Status",
    options: [
      { label: "New", value: HardwareOrderStatus.NEW },
      { label: "Approved", value: HardwareOrderStatus.APPROVED },
      { label: "Assigned", value: HardwareOrderStatus.ASSIGNED },
      { label: "Work In Progress", value: HardwareOrderStatus.WORK_IN_PROGRESS },
      { label: "Pending Quote", value: HardwareOrderStatus.PENDING_QUOTE },
      { label: "Pending Requester Info", value: HardwareOrderStatus.PENDING_REQ_INFO },
      { label: "Pending Approval", value: HardwareOrderStatus.PENDING_APPROVAL },
      { label: "Pending Delivery", value: HardwareOrderStatus.PENDING_DELIVERY },
    ]
  },
  {
    label: "Complete Status",
    options: [
      { label: "Cancelled", value: HardwareOrderStatus.CANCELLED },
      { label: "Delivered", value: HardwareOrderStatus.DELIVERED },
      { label: "Rejected", value: HardwareOrderStatus.REJECTED }
    ]
  }
];